import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SidebarState {
  isOpen: boolean;
  isFixed: boolean;
}

const initialState: SidebarState = {
  isOpen: false,
  isFixed: false,
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.isOpen = !state.isOpen;
    },
    setSidebarOpen(state, action: PayloadAction<boolean>) {
      state.isOpen = action.payload;
    },
    setSidebarFixed(state, action: PayloadAction<boolean>) {
      state.isFixed = action.payload;
    },
  },
});

export const { toggleSidebar, setSidebarOpen, setSidebarFixed } = sidebarSlice.actions;
export default sidebarSlice.reducer;
